import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import ActionBar from "~/layout/ActionBar";
import {Col, Row, Skeleton} from "antd";

import _ from "lodash"

import {
	WebsiteReportTotal,
	WebsiteReportGroup,
	WebsiteReportSearch
} from "../../components";

import {
	apiError,
	handleRequest
} from "~/utils";

import {
	reportApi
} from "~/api";
import {
	useCan,
	useGroup
} from "~/hooks";

function WebsiteReport() {

	const plus = useCan('revenuePlus');

	//Group items
	const listGroup = useGroup();

	const [items, setItems] = useState([]);

	const [loading, setLoading] = useState(false);

	const [filter, setFilter] = useState({
		groupId : undefined,
		service : '',
		confirm : 0,
		type : plus ? 0 : 1,
		type1 : 0,
		type2 : 0,
	});

	//Load data
	useEffect(() => { handleLoad(); }, [filter]);

	const handleLoad = async () => {
		setLoading(true);
		let [error, response] = await handleRequest(reportApi.website(filter));
		let message = apiError(`Lấy thông tin báo cáo thất bại`, error, response);
		if (!message) {
			setItems(response.data)
		}
		setLoading(false);
	}

	const handleFilterChange = (key, value) => {
		const newFilter = {
			...filter,
			[key]: value,
			page: 1
		};
		setFilter(newFilter);
	};

	return (
		<>
			<ActionBar title={'Hợp đồng'}></ActionBar>
			<div className={'container'}>
				<div className="content pd-1 pdb-3 form" style={{overflow:'auto'}}>
					<WebsiteReportSearch filter={filter} listGroup={listGroup} onChange={handleFilterChange} />
					<Row gutter={10}>
						<Col className="gutter-row" md={16} span={24} lg={18}>
							{loading && <Skeleton />}
							{(!loading && !_.isEmpty(items)) &&
								Object.keys(items.groups).map((itemKey) => {
									let item = items.groups[itemKey];
									return <WebsiteReportGroup key={`WebsiteReportGroup${itemKey}`} item={item}/>
								})
							}
						</Col>
						<Col className="gutter-row" md={8} span={24} lg={6} >
							<div className="content-shadow pd-1 mt-0">
								{loading && <Skeleton />}
								{(!loading && !_.isEmpty(items)) && <WebsiteReportTotal summary={items.summary} />}
							</div>
						</Col>
					</Row>
				</div>
			</div>
		</>
	)
}

export default WebsiteReport;